module.exports = __webpack_public_path__ + "static/media/checked.e6b1b07a.svg";